// extracted by mini-css-extract-plugin
export var createdDate = "_mr-1";
export var divider = "_mr-2";
export var headerDivider = "_mr-3";
export var messagesCard = "_mr-0";
export var messagesContainer = "_mr-7";
export var messagesContainerWrapper = "_mr-4";
export var pointerCapturingButtonBoxes = "_mr-a";
export var showLeftPanelButton = "_mr-9";
export var showMoreButton = "_mr-c";
export var showMoreButtonContainer = "_mr-b";
export var summaryTitle = "_mr-6";
export var systemMessageCardWrapper = "_mr-d";
export var topButtons = "_mr-8";
export var withPadding = "_mr-5";